'use client'

import { createContext } from 'react'

import { HomepageTabModel } from '@marketplace-web/home/home-page-data'

export type HomeContextType = {
  homepageSessionId: string
  tabs: Array<HomepageTabModel>
}

const HomeContext = createContext<HomeContextType>({
  // These fallback values will never be used, as the provider is required
  homepageSessionId: '',
  tabs: [],
})

export default HomeContext
